import bobtailAPI from '../axiosConfig'

export default class ApiService {
  static baseUrl = '/api/services'

  static async checkPhoneConnected (params) {
    return (await bobtailAPI()).post(`${ApiService.baseUrl}/phone-number/validate`, {
      ...params,
    })
  }

  static async getConfig (params) {
    return (await bobtailAPI()).get(`${ApiService.baseUrl}/config`, {
      params: {
        forceRead: true,
        ...params,
      },
    })
  }

  static async getFilestackSecurity (params) {
    return (await bobtailAPI()).get(`${ApiService.baseUrl}/get-filestack-security`, {
      ...params,
    })
  }
}
